import { render, staticRenderFns } from "./tabRoute.vue?vue&type=template&id=b346d212&scoped=true"
import script from "./tabRoute.vue?vue&type=script&lang=js"
export * from "./tabRoute.vue?vue&type=script&lang=js"
import style0 from "./tabRoute.vue?vue&type=style&index=0&id=b346d212&prod&lang=scss"
import style1 from "./tabRoute.vue?vue&type=style&index=1&id=b346d212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b346d212",
  null
  
)

export default component.exports